import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Footer from "../components/footer";
import NavigationBar from "../components/navigationbar";
import MasjidLogos from "../components/masjidLogos";
import ZakatChart from "../components/zakatchart";
import greenBanner from "../assets/greenbanner.png";
import { MdFamilyRestroom } from "react-icons/md";
import { FaWheelchair } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { RiHeartsFill } from "react-icons/ri";
import { GiHandcuffs } from "react-icons/gi";
import { FaMoneyBillWave } from "react-icons/fa";
import { BsMoonStars } from "react-icons/bs";
import { IoFootstepsSharp } from "react-icons/io5";
import testimonials from "../components/testimonials";

const iconComponents = [
  <MdFamilyRestroom />,
  <FaWheelchair />,
  <GiReceiveMoney />,
  <RiHeartsFill />,
  <GiHandcuffs />,
  <FaMoneyBillWave />,
  <BsMoonStars />,
  <IoFootstepsSharp />,
];

const categories = [
  "Families in Need",
  "People With Special Needs",
  "Zakat Administrators",
  "Reconciled Hearts",
  "Captives",
  "Debt Ridden",
  "Fi-SibillAllah",
  "Wayfarer",
];



export const HomePage = () => {
  return (
    <div className="home-page">
      <NavigationBar />
      <div
        style={{
          backgroundImage: `url(${greenBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "1rem 3rem",
          fontFamily: "Lora, serif",
        }}
      >
        <Container className="px-4">
          <div style={{ fontSize: 14, paddingBottom: "1rem", textAlign: "center" }}>
            Nueces Mosque • ICGA • ICRR • ICBC • ICLT • GIC • QCIC • Al-Noor MCC • ICHC
          </div>

          {/* Content row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1.5rem",
              gap: "2rem",
              flexWrap: "wrap",
            }}
          >
            {/* Left side */}
            <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
              <div style={{ fontSize: 32, fontWeight: "700", marginBottom: "0.5rem" }}>
                Greater Austin Muslim Relief Committee:
              </div>
              <div style={{ fontSize: 20, fontWeight: "600", paddingRight: "4rem" }}>
                A Unified Zakah Committee Nurturing Communities in The Greater Austin Area
              </div>
            </div>

            {/* Right side */}
            <div style={{ flex: "1 1 400px", minWidth: "280px", display: "flex", flexDirection: "column" }}>
              <p style={{ fontSize: 18, lineHeight: 1.5, marginBottom: "1.5rem" }}>
                The Greater Austin Muslim Relief Committee (GAMRC) is dedicated to providing financial and humanitarian assistance to community members in need. We serve all eight categories of Zakat, as outlined in Surah At-Tawbah, which include the poor, the needy, Zakat administrators, reconciled hearts, captives, dept ridden , Fi-SibillAllah, and travelers in need.
              </p>

              <div style={{ display: "flex", gap: "1rem" }}>
                <Button href="/ApplyForHelp" className="nav-button apply-button">
                  Apply For Help
                </Button>

                <Button href="/PayZakatHere" className="nav-button zakat-button" >
                  Pay Zakat Here
                </Button>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div
        style={{
          backgroundColor: "#BF5700",
          color: "white",
          padding: "6px 12px",
          textAlign: "center",
          fontSize: "20px",
          fontWeight: "600",
        }}
      >
        <a
          href="/Nueces"
          style={{
            color: "white",
            textDecoration: "none",
          }}
        >
          GAMRC supports Nueces Mosque Reconstruction — More Info →
        </a>
      </div>
      <div
        style={{
          backgroundColor: "#184780",
          color: "white",
          padding: "6px 12px",
          textAlign: "center",
          fontSize: "20px",
          fontWeight: "600",
        }}
      >
        <a
          href="/Eid-Al-Adha"
          style={{
            color: "white",
            textDecoration: "none",
          }}
        >
          Eid-Al-Adha Qurbani - More Info →
        </a>
      </div>
      <Container className="my-5">
        <div className="d-flex flex-wrap justify-content-between align-items-center my-5 px-4" style={{ gap: "2rem" }}>
          <Col xs={12} md={5} className="text-center">
            <h2 style={{ fontWeight: 700 }}>
              United for the good of humanity and the good of our community (Muslims and non-Muslims)
            </h2>
            <Button
              href="/NonMuslims"
              style={{
                backgroundColor: "#42226D",
                width: "300px",
                marginTop: "1.5rem",
                fontWeight: 600,
                borderRadius: "6px"
              }}
              className="nav-button"
              target="_blank"
            >
              Non Muslims Support
            </Button>
          </Col>
          <Col className="text-center">
            <div style={{ backgroundColor: "#D4C5E4", borderRadius: "10px", padding: "1.5rem", }} >
              <p>
                The Greater Austin Muslim Relief Committee is NOT an organization.
                We are a unified committee of all the local Austin masajid. You can
                pay your Zakat at the masajid linked below. The Zakat will then be
                distributed through GAMRC to those in need.
              </p>
            </div>
          </Col>
        </div>
        <hr className="my-4" style={{ height: '2px', backgroundColor: 'black' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0' }}>
          <Row>
            <div style={{ flex: 1, marginRight: '20px' }}>
              <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>Where Does The Zakat Go?</h2>
              <p style={{ fontSize: '16px', color: '#000' }}>
                GAMRC helps support vulnerable families in austin by paying for rent,
                electricity, food and some cases of urgent debts and medical expenses.
                Provides support to domestic violence cases, single moms, widows, and
                orphans.  Provides a food basket twice during the blessed month of Ramadan.
                Operates a space in a low-income complex for refugee kids to attend
                quran classes and educational programs.
              </p>
              <Button
                href="/WhatWeDo"
                style={{ backgroundColor: "#42226D", borderColor: "#42226D", width: "200px" }}
                className="nav-button"
                target="_blank">
                What We Do
              </Button>
            </div>

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', maxHeight: '40vh', minHeight: '30vh', marginTop: '0px' }}>
              <ZakatChart />
            </div>
          </Row>
        </div>
        <Col>
          <hr style={{ height: '2px', backgroundColor: 'black' }} />
          <h2>Voices From Our Community</h2>
          <Row className="g-3">
            {testimonials.slice(0, 3).map((t, i) => (
              <Col key={i} md={4}>
                <div
                  style={{
                    backgroundColor: "#D4DFCB",
                    borderRadius: "12px",
                    padding: "20px",
                    minHeight: "180px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    color: "#1b2e1bff",
                    fontStyle: "italic",
                  }}
                  href="/Testimonials"
                >
                  <div>“{t.quote}”</div>
                  <div style={{ alignSelf: "flex-end", fontStyle: "normal", fontWeight: "600", marginTop: "10px" }}>
                    — {t.name}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
            <a
              href="/Testimonials"
              style={{
                textDecoration: "none",
                color: "#1b2e1bff",
                fontWeight: "500",
                fontSize: "16px"
              }}
            >
              See more →
            </a>
          </div>
        </Col>


        <Col className="text-center my-4">

          <hr style={{ height: '2px', backgroundColor: 'black' }} />

          <p>
            Donate <a href="/PayZakatHere">here</a> or give your Zakat through Austin-area masajid to
            help strengthen your community.
          </p>
          <MasjidLogos />
          <p style={{ fontSize: '16px', color: '#000' }}>JazakAllah Khair to our most generous communities at Nueces Mosque, ICBC and ICGA</p>
        </Col>


        <div>
          <hr style={{ height: '2px', backgroundColor: 'black' }} />

          <h1
            style={{ color: '#31572C' }}
            className="text-center my-4 mx-4"
          >
            إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ وَالْعَامِلِينَ عَلَيْهَا وَالْمُؤَلَّفَةِ قُلُوبُهُمْ وَفِي الرِّقَابِ وَالْغَارِمِينَ وَفِي سَبِيلِ اللَّهِ وَابْنِ السَّبِيلِ فَرِيضَةً مِّنَ اللَّهِ وَاللَّهُ عَلِيمٌ حَكِيمٌ
          </h1>
          <p
            className="text-center pb-4"
            style={{ fontSize: '18px' }}
          >
            "Zakat expenditures are only for the poor and for the needy and for those employed to
            collect [zakat] and for bringing hearts together [for Islam] and for freeing captives
            and for those in debt and for the cause of Allah and for the [stranded] traveler. This
            is an obligation from Allah, and Allah is All-Knowing, All-Wise." (9:60)
          </p>
        </div>

        <Row className="my-5 mx-3 align-items-stretch" style={{ minHeight: "320px" }}>
          <Col xs={12} lg={8}>
            <Row className="g-3 h-100">
              {categories.map((category, idx) => (
                <Col key={idx} xs={6} md={3}>
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-center h-100 w-100 p-3"
                    style={{
                      borderRadius: "10px",
                      height: "150px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div style={{ fontSize: "32px", color: "#31572C", marginBottom: "0.5rem" }}>
                      {iconComponents[idx]}
                    </div>
                    <div style={{ fontSize: "16px", fontWeight: "500" }}>{category}</div>
                  </div>
                </Col>
              ))}
              <p style={{ fontSize: '12px', textAlign: 'center' }}>Although Zakat administrators are eligible to receive from Zakat funds, all of our
                volunteers serve purely out of goodwill and for the sake of Allah. Please keep them in your duas.</p>
            </Row>
          </Col>
          <Col xs={12} lg={4}>
            <div
              className="h-100 d-flex align-items-center justify-content-center text-center"
              style={{
                backgroundColor: "#88AC68B8",
                padding: "2rem",
                borderRadius: "10px",
              }}
            >
              <h2 style={{ fontWeight: "600" }}>
                Keep your Zakat local. Your duty begins with your community.
                Together, we can strengthen the Austin ummah by uplifting
                families in need.
              </h2>
            </div>
          </Col>
        </Row>

      </Container>
      <Footer />
    </div>
  );
};

export default HomePage;
